import { render } from "./EventList.vue?vue&type=template&id=1e306abe&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"

import "./EventList.vue?vue&type=style&index=0&id=1e306abe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e306abe"

export default script